import TermsAndCondition from "../components/common/TermsAndCondition";
import BlogDetails from "../components/User/Blog/BlogDetails";
import AdminBlog from "../screens/auth/AdminBlog";
import AdminCalculator from "../screens/auth/AdminCalculator";
import AdminCarrier from "../screens/auth/AdminCarrier";
import AdminDashboard from "../screens/auth/AdminDashboard";
import AdminInquiries from "../screens/auth/AdminInquiries";
import AdminProductDetails from "../screens/auth/AdminProductDetails";
import AdminProducts from "../screens/auth/AdminProducts";
import AdminProfile from "../screens/auth/AdminProfile";
import AdminProjectDetail from "../screens/auth/AdminProjectDetail";
import AdminProjects from "../screens/auth/AdminProjects";
import AdminReview from "../screens/auth/Adminreview";
import ProductForm from "../screens/auth/Calculator/ProductForm";
import AdminLogin from "../screens/nonAuth/AdminLogin";
import About from "../screens/users/About";
import Blogs from "../screens/users/Blogs";
import Carrier from "../screens/users/Carrier";
import ConcreteCalculator from "../screens/users/ConcreteCalculator";
import Contact from "../screens/users/Contact";
import Home from "../screens/users/Home";
import ProductDetails from "../screens/users/ProductDetails";
import Products from "../screens/users/Products";
import ProjectDetails from "../screens/users/ProjectDetails";
import Projects from "../screens/users/Projects";
import AdminCalculatorInquiry from "../screens/auth/AdminCalculatorInquiry";
import Cart from "../screens/users/Cart";
import AdminConcreteMix from "../screens/auth/Adminconcretemix";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <AdminDashboard />,
  },
  {
    path: "/products",
    component: <AdminProducts />,
  },
  {
    path: "/blogs",
    component: <AdminBlog />,
  },
  {
    path: "/products/:id",
    component: <AdminProductDetails />,
  },
  {
    path: "/projects",
    component: <AdminProjects />,
  },
  {
    path: "/projects/:id",
    component: <AdminProjectDetail />,
  },
  {
    path: "/carriers",
    component: <AdminCarrier />,
  },
  {
    path: "/inquiries",
    component: <AdminInquiries />,
  },
  {
    path: "/review",
    component: <AdminReview />,
  },
  {
    path: "/profile",
    component: <AdminProfile />,
  },
  {
    path: "/admin-calculator",
    component: <AdminCalculator />,
  },
  {
    path: "/admin-calculator-products/add",
    component: <ProductForm />,
  },
  {
    path: "/admin-calculator-products/edit/:id",
    component: <ProductForm />,
  },
  {
    path: "/calculatorInquiries",
    component: <AdminCalculatorInquiry />,
  },
   {
    path: "/admin-estimatecalxulation",
    component: <AdminConcreteMix />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/admin/login",
    component: <AdminLogin />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/carrier",
    component: <Carrier />,
  },
  {
    path: "/blog",
    component: <Blogs />,
  },
  {
    path: "/blog/:id",
    component: <BlogDetails />,
  },
  {
    path: "/products",
    component: <Products />,
  },
  {
    path: "/projects",
    component: <Projects />,
  },
  {
    path: "/products/:id",
    component: <ProductDetails />,
  },
  {
    path: "/projects/:id",
    component: <ProjectDetails />,
  },
  {
    path: "/calculator",
    component: <ConcreteCalculator />,
  },
  {
    path: "/termsandconditions",
    component: <TermsAndCondition />,
  },
  {
    path: "/cart",
    component: <Cart />,
  },
];
